// extracted by mini-css-extract-plugin
export default {"page":"jV","headerwrap":"kV","headerblock":"lV","textwrapper":"mV","text":"nV","closerlook":"oV","arrowwrap":"pV","icon":"qV","updown":"rV","products":"sV","system":"tV","systemimage":"uV","cards":"vV","note":"wV","fadein":"xV"};
    if(module.hot) {
      // 1743628928047
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  